export const message = 'MESSAGE';
export const isVisible = 'ISVISIBLE';

export const setMessage = (messageData) => {
  return { 
  		type: message, 
  		messageData 
  	}
}

export const setIsVisible = (visible) => {
	
	return {
		type: isVisible,
		visible
	}
}


// WEBPACK FOOTER //
// ./src/actions/message.js